import { fetchUserInfo } from '@/apis/user';
import { logout, restoreSession } from '@/store/modules/user';
import { refreshAccessToken, cookieAuthEnabled } from '@/utils/request';

// Cookie 模式下尝试使用 HttpOnly refresh cookie 恢复会话。
const initializeAuth = async store => {
  if (!cookieAuthEnabled) return;

  try {
    const accessToken = await refreshAccessToken();
    store.dispatch(restoreSession(accessToken));
    await store.dispatch(fetchUserInfo());
  } catch (error) {
    store.dispatch(logout());
  }
};

export default initializeAuth;
